/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import './ProductImport.scss'
import RenderTabs from "../../components/ui/tab/RenderTab";
import { OpenStatusType } from "../../utils/Enums/CommonEnums";
import CardSection from "../../components/ui/card/CardSection";
import { useGetSchedulerStatusQuery } from "../../app/services/productImportAPI";
import { formatDate } from "../../lib/formatDate";

const ProductImportOpenTab = React.lazy(() =>
  import("./ProductImportOpenTab")
);

const ProductImport = () => {
  // First call — fetch immediately to get checkIntervalMinutes from the server
  const { data: initialData } = useGetSchedulerStatusQuery(undefined, {
    pollingInterval: 0, // no repeat yet, just get the interval value
  });

  // Use the interval from appsettings (returned by the API), default 5 min if not yet loaded
  const pollIntervalMs = initialData?.checkIntervalMinutes
    ? initialData.checkIntervalMinutes * 60 * 1000
    : 300000; // 5 min fallback

  // Main poll — uses the configurable interval from appsettings
  const { data: statusData, isLoading } = useGetSchedulerStatusQuery(undefined, {
    pollingInterval: pollIntervalMs,
  });

  const tabs = [
    {
      sMenuItemCaption: "Open",
      sPage: '',
      icon: 'mdi:format-list-bulleted',
      component: <ProductImportOpenTab openStatus={OpenStatusType.OPEN} />
    },
    {
      sMenuItemCaption: "Archive",
      sPage: '',
      icon: 'mdi:format-list-bulleted',
      component: <ProductImportOpenTab openStatus={OpenStatusType.ARCHIVE} />
    }
  ];

  return (
    <CardSection cardTitle={"Product Import"}>
      <div className="scheduler-status-container">
        <div className="status-row">
          <div className="scheduler-status-item">
            <span>ChemIndex Product Import Scheduler:</span>
            {!isLoading && statusData ? (
              <span className={`status-pill ${statusData.isActive ? 'active' : 'inactive'}`}>
                {statusData.isActive ? 'Active' : 'Inactive'}
              </span>
            ) : (
              <span className="status-pill">Checking...</span>
            )}
          </div>
        </div>
        {!isLoading && statusData && statusData.lastChecked && (
          <div className="last-checked">
            Last checked: {formatDate(statusData.lastChecked, 'M/D/YYYY, h:mm:ss A')}
          </div>
        )}
      </div>
      <RenderTabs
        tabs={tabs}
        isCollapse={false}
        isOrganization={false}
        onActiveTab={() => { }}
        onTabClick={() => { }}
      />
    </CardSection>
  );
};

export default ProductImport;
